import { createTheme } from '@mui/material/styles';

/**
 * Enterprise-style dashboard theme: restrained palette, no “playful” defaults,
 * Inter matches public/index.html font load.
 */
const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#0f172a',
      light: '#334155',
      dark: '#020617',
      contrastText: '#f8fafc',
    },
    secondary: {
      main: '#2563eb',
      dark: '#1d4ed8',
      light: '#3b82f6',
      contrastText: '#ffffff',
    },
    background: {
      default: '#f1f5f9',
      paper: '#ffffff',
    },
    text: {
      primary: '#0f172a',
      secondary: '#64748b',
    },
    divider: 'rgba(15, 23, 42, 0.08)',
    action: {
      hover: 'rgba(15, 23, 42, 0.04)',
      selected: 'rgba(37, 99, 235, 0.08)',
    },
  },
  shape: {
    borderRadius: 12,
  },
  typography: {
    fontFamily:
      '"Inter", system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    h1: { fontWeight: 700, letterSpacing: '-0.02em' },
    h2: { fontWeight: 700, letterSpacing: '-0.02em', fontSize: '1.5rem' },
    h3: { fontWeight: 600, letterSpacing: '-0.01em', fontSize: '1.25rem' },
    h4: { fontWeight: 600 },
    subtitle1: { fontWeight: 600 },
    button: { fontWeight: 600, textTransform: 'none' },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          scrollbarGutter: 'stable',
        },
      },
    },
    MuiButton: {
      defaultProps: {
        disableElevation: true,
      },
      styleOverrides: {
        root: {
          borderRadius: 10,
          alignItems: 'center',
          justifyContent: 'center',
          lineHeight: 1.5,
          padding: '8px 16px',
        },
        sizeSmall: {
          padding: '6px 12px',
        },
        sizeLarge: {
          padding: '10px 22px',
        },
      },
    },
    MuiPaper: {
      defaultProps: {
        elevation: 0,
      },
      styleOverrides: {
        root: {
          backgroundImage: 'none',
          border: '1px solid',
          borderColor: 'rgba(15, 23, 42, 0.08)',
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          borderBottom: '1px solid',
          borderColor: 'rgba(15, 23, 42, 0.08)',
        },
      },
    },
    MuiTextField: {
      defaultProps: {
        variant: 'outlined',
        size: 'medium',
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          alignItems: 'center',
          '&.MuiInputBase-multiline': {
            alignItems: 'stretch',
          },
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          alignItems: 'center',
        },
      },
    },
    MuiFormControl: {
      defaultProps: {
        size: 'medium',
      },
    },
    MuiCheckbox: {
      defaultProps: {
        size: 'small',
      },
    },
    MuiFormControlLabel: {
      styleOverrides: {
        root: {
          marginLeft: 0,
          marginRight: 0,
        },
      },
    },
  },
});

export default theme;
